import { DateTime } from "luxon";

import { View, ViewKeyMap } from "../../types/Views";
import IUserEvent, { UserEventType } from "./IUserEvent";

class ViewArrivalUserEvent implements IUserEvent<View> {
  readonly type = UserEventType.ViewArrival;
  readonly timestamp: DateTime;
  readonly value: View;

  constructor(routePathName: string) {
    this.timestamp = DateTime.now();
    const mappedView = Object.values(ViewKeyMap).find(({ uri }) => routePathName === uri);
    if (!mappedView) throw new Error(`Could not find a view mapping for the provided event data: ${routePathName}`);
    this.value = mappedView.key;
  }
}

export default ViewArrivalUserEvent;
